<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

let globalId = 0;
export default defineComponent({
  name: 'OIconAvatar',
  svgType: 'fill',
  setup() {
    const classNames = ['o-svg-icon', 'o-icon-avatar', 'type-fill'];
    const isClient = ref(false);
    onMounted(() => {
      isClient.value = true;
    });
    return {
      isClient,
      classNames,
      globalId: globalId++,
    };
  },
});
</script>
<template>
  <svg viewBox="0 0 48 48" :class="classNames">
    <template v-if="isClient">
      <circle cx="24" cy="24" r="24" opacity=".2"/><path fill-opacity=".9" d="M23.92 30.857c11.31 0 14.263 6.778 15.33 9.048q.057.118.108.243A22.2 22.2 0 0 1 24 46.286c-6.01 0-11.465-2.38-15.473-6.248l.063-.133c1.117-2.27 4.02-9.048 15.33-9.048m0-19.714a8.143 8.143 0 1 1 0 16.286 8.143 8.143 0 0 1 0-16.286"/>
    </template>
  </svg>
</template>